<template>
	<div id="">
		<system-requirements-section />
		<trynow-section
			:subtitle="trynow_section_data.subtitle"
			:title="trynow_section_data.title"
			:description="trynow_section_data.description"
			:btn-text="trynow_section_data.cta"
			:icon="trynow_section_data.icon"
			:image="trynow_section_data.image"
			:link="trynow_section_data.link"
		/>

		<Head>
			<Title v-if="metadata">{{ metadata?.title }}</Title>
			<Meta
				name="description"
				content="StocksToTrade is a proprietary algorithmic trading tool. See if your system is ready to unlock your trading potential"
			/>
			<Meta
				name="og:description"
				content="StocksToTrade is a proprietary algorithmic trading tool. See if your system is ready to unlock your trading potential"
			/>

			<Meta
				:property="metadata.property"
				:content="metadata.content"
				v-if="metadata && metadata.property"
			/>
			<Meta
				:name="metadata.name"
				:content="metadata.content"
				v-else-if="metadata && metadata.name"
			/>

			<Link
				:href="config.current_hostname.slice(0, -1) + '/system-requirements/'"
				rel="canonical"
			/>
			<Meta
				:content="config.current_hostname.slice(0, -1) + '/system-requirements/'"
				property="og:url"
			/>
		</Head>
	</div>
</template>

<script>
export default defineNuxtComponent({
	setup() {
		const config = useRuntimeConfig().public;
		const router = useRoute();

		return {
			config,
			router
		};
	},

	async asyncData({ $config }) {
		const results = await $fetch(
			`${$config.public["hostname"]}wp-json/wp/v2/pages?slug=system-requirements&_embed`
		);
		const page = results?.[0];

		if (!page) {
			throw createError({
				statusCode: 404,
				fatal: true
			});
		}

		return {
			post: page,
			metadata: page.yoast_head_json,
			yoast: page.yoast_head
		};
	},
	data() {
		return {
			page: null,
			showTutorial: false,
			trynow_section_data: {
				subtitle: "NO TIME WASTED",
				title: "Empowering The Every Day Trader",
				description:
					"When every second matters- there isn’t time to sift through masses of data to find those actionable trades.Try StocksToTrade for 14 days and see how it can change the way you trade.",
				cta: "Try Now For $7",
				link: "/plans",
				image: "/images/top-features-img5.jpg",
				icon: "/images/about-icon3.svg"
			}
		};
	},
	head_schema_seo() {
		const experiment = Object.entries(this.metadata);
		const filtered = experiment.filter((item) =>
			["canonical", "schema_json"].includes(item[0])
		);
		return filtered;
	},
	head_seo() {
		const experiment = Object.entries(this.metadata);
		const filtered = experiment.filter(
			(item) =>
				![
					"title",
					"robots",
					"canonical",
					"schema_json",
					"WordPressAuthor_YoastHeadJson_Schema_"
				].includes(item[0])
		);
		return filtered;
	}
});
</script>

<style lang="scss" scoped></style>
